module.exports = "<footer class=\"footer\">\n  <div class=\"row\">\n    <div class=\"col-sm-4\">\n        <img src=\"assets/images/logo.png\" alt=\"\">\n      </div>\n      <div class=\"col-sm-4\">\n        <p>Copyright 2018, Andrew Yule Group</p>\n      </div>\n      <div class=\"col-sm-4\">\n        <p class=\"powered\">Powered by <a href=\"http://www.experisindia.com/\" target=\"_blank\">Experis IT</a></p>\n      </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main